/**
 * The text to send from what was typed. Blank lines before the first line and spaces and blank lines
 * after the last are removed. The first line keeps its indentation, as a code sample needs. A
 * message of nothing but spaces and line breaks is empty, and is not sent.
 */
export function messageBody(draft: string): string {
  if (!draft.trim()) return "";
  return draft.replace(/^(?:[^\S\n]*\n)+/, "").replace(/\s+$/, "");
}
